
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/practical-informations/[...uid]",
      function () {
        return require("private-next-pages/practical-informations/[...uid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/practical-informations/[...uid]"])
      });
    }
  